import React, { useState } from "react";
import classes from "./ColumnOptionsOverlay.scss";
import { IconButton, Tooltip } from "@toddle-edu/ds-web";
import { AddColumnOutlined, DeleteOutlined } from "@toddle-edu/ds-icons";
import { elevations } from "@toddle-edu/ds-theme";
import PropTypes from "prop-types";
import { Dialog } from "@toddle-edu/ds-web";

// component to add cols to left or right, or delete cols.
const ColumnOptionsOverlay = React.memo(
  ({
    deleteCol,
    index,
    id,
    addCol,
    addColumnDisabled,
    t,
    testId,
    deleteColumnDisabled,
  }) => {
    const addColBefore = () => addCol(index);
    const addColAfter = () => addCol(index + 1);
    const deleteColIndex = () => deleteCol(id);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const toggleDeleteDialog = () => {
      setShowDeleteDialog(!showDeleteDialog);
    };

    return (
      <div className={classes.container} style={elevations["elevation-2B"]}>
        <Tooltip
          tooltip={t("common:label_count", {
            count: t("worksheet:add_column"),
            label: t("worksheet:before"),
          })}
        >
          <IconButton
            icon={<AddColumnOutlined variant={"subtle"} />}
            variant="subtle"
            onMouseDown={addColBefore}
            disabled={addColumnDisabled}
            // same icon rotated 180deg
            className={classes.reverseY}
            size="small"
            testId={`${testId}-ColumnOptionsOverlay-AddColBefore`}
          ></IconButton>
        </Tooltip>
        <Tooltip
          tooltip={t("common:label_count", {
            count: t("worksheet:add_column"),
            label: t("worksheet:after"),
          })}
        >
          <IconButton
            icon={<AddColumnOutlined variant={"subtle"} />}
            variant="subtle"
            onMouseDown={addColAfter}
            disabled={addColumnDisabled}
            size="small"
            testId={`${testId}-ColumnOptionsOverlay-AddColAfter`}
          ></IconButton>
        </Tooltip>
        <div className={classes.divider} />
        <Tooltip tooltip={t("worksheet:delete_column")}>
          <IconButton
            icon={<DeleteOutlined variant={"subtle"} />}
            variant="subtle"
            onMouseDown={toggleDeleteDialog}
            disabled={deleteColumnDisabled}
            size="small"
            testId={`${testId}-ColumnOptionsOverlay-DeleteCol`}
          ></IconButton>
        </Tooltip>
        {showDeleteDialog ? (
          <Dialog
            title={t("common:delete_with_label", {
              label: t(`common:column`),
            })}
            message={t("common:this_action_cannot_be_undone")}
            buttonOneText={t("common:cancel")}
            buttonTwoText={t("common:delete")}
            onButtonOneClick={toggleDeleteDialog}
            onButtonTwoClick={deleteColIndex}
            isClosable={true}
            onClose={toggleDeleteDialog}
            testId={`${testId}-ColumnOptionsOverlay-DeleteDialog`}
          />
        ) : null}
      </div>
    );
  }
);

ColumnOptionsOverlay.displayName = "ColumnOptionsOverlay";

ColumnOptionsOverlay.propTypes = {
  deleteCol: PropTypes.func,
  addCol: PropTypes.func,
  index: PropTypes.number,
  addColumnDisabled: PropTypes.bool,
  testId: PropTypes.string,
};
export default ColumnOptionsOverlay;
